// extracted by mini-css-extract-plugin
module.exports = {"marqueeContainer":"ProductPageHeader_marqueeContainer__IZK1S","marquee":"ProductPageHeader_marquee__cVxrD"};